import styled from 'styled-components'

import { palette } from '_styles/variables'

import {
  getArrowPositions,
  getTooltipPositions,
  positionToCss,
  getArrowShape,
} from '../helpers/functions'
import { Placement } from '../helpers/types'

export const Body = styled.div<{
  placement: Placement
  x: number | null
  y: number | null
}>`
  padding: 0.5rem;
  border-radius: 0.125rem;
  box-sizing: border-box;
  background-color: ${palette.brand.teal};
  color: ${palette.neutral.white};
  font-size: 0.75rem;
  max-width: 15rem;
  line-height: 1rem;
  ${positionToCss(getTooltipPositions)}

  &::after {
    ${getArrowShape}
    ${positionToCss(getArrowPositions)}
  }
`
